namespace appn.views.shared.updateFormEntryDialog {

    class InitArgs {
        closeModal: boolean = false;
    }

    export function init(args: InitArgs): void {
        addEvents();

        if (args.closeModal)
            appn.iframe.closeModal();
    }

    function addEvents() {
        $('#updatedAttachFile').on('change', function (e) {
            const fileUploadWidget = $('#updatedAttachFile');
            const btnParent = fileUploadWidget.closest('.btn-file');
            const text = btnParent.find('.fileinput-new.lead');
            if (utils.hasValue(text)) {
                const updatedFile: File = (fileUploadWidget as any)[0].files[0];
                text.attr('style', 'display: inline-flex; align-items: center;')
                text.html(`<i class="fa-2x mr-2"></i> ${updatedFile.name}`);
            }
        });
    }
}
